import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

type ReofferedColorSet = {
  unchanged: string;
  increased: string;
  decreased: string;
};

const DEFAULT_COLORS: ReofferedColorSet = {
  unchanged: 'neutral.600',
  increased: 'primary.main',
  decreased: 'error.600',
};

const NEOBET_COLORS: ReofferedColorSet = {
  unchanged: 'neutral.200',
  increased: 'success.400',
  decreased: 'error.300',
};

export const REOFFERED_COLOR_SKIN_STYLES: SkinStylesMap<ReofferedColorSet> = {
  [SKIN.BET365]: DEFAULT_COLORS,
  [SKIN.GOLA]: DEFAULT_COLORS,
  [SKIN.NEOBET]: NEOBET_COLORS,
};
